var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _text, _g, _rect7, _rect8, _rect9, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _path16, _ellipse, _ellipse2, _path17, _path18, _circle3, _circle4, _path19, _path20, _text2, _path21, _path22, _g3, _rect10, _path23, _path24, _path25, _rect11, _rect12, _path26, _circle5, _circle6, _path27, _path28, _ellipse3, _ellipse4, _circle7, _text3, _path29, _path30, _circle8, _path31, _path32, _path33, _circle9, _circle10, _path34, _circle11, _circle12, _path35, _circle13, _circle14, _path36, _circle15, _circle16, _path37, _circle17, _circle18, _path38, _circle19, _circle20, _path39, _circle21, _circle22, _path40, _circle23, _circle24, _path41, _circle25, _circle26, _path42, _circle27, _circle28, _path43, _circle29, _circle30, _path44, _circle31, _circle32, _path45, _circle33, _circle34, _path46, _circle35, _circle36, _path47, _circle37, _circle38, _path48, _circle39, _circle40, _path49, _circle41, _circle42, _path50, _circle43, _circle44, _path51, _circle45, _circle46, _path52, _circle47, _circle48, _path53, _circle49, _circle50, _path54, _circle51, _circle52, _path55, _circle53, _circle54, _path56, _circle55, _circle56, _path57, _circle57, _circle58, _path58, _circle59, _circle60, _path59, _circle61, _circle62, _path60, _circle63, _circle64, _path61, _circle65, _circle66, _path62, _circle67, _circle68, _path63, _circle69, _circle70, _path64, _circle71, _circle72, _path65, _circle73, _circle74, _path66, _circle75, _circle76, _path67, _circle77, _circle78, _path68, _circle79, _circle80, _path69, _circle81, _circle82, _path70, _circle83, _circle84, _path71, _circle85, _circle86, _circle87, _path72, _circle88, _circle89, _path73, _circle90, _circle91, _path74, _circle92, _circle93, _path75, _circle94, _circle95, _path76, _circle96, _circle97, _path77, _circle98, _circle99, _path78, _circle100, _circle101, _path79, _circle102, _circle103, _path80, _circle104, _circle105, _path81, _circle106, _circle107, _path82, _circle108, _circle109, _path83, _circle110, _circle111, _circle112, _path84, _circle113, _circle114, _path85, _circle115, _circle116, _path86, _circle117, _circle118, _path87, _circle119, _circle120, _path88, _circle121, _circle122, _path89, _circle123, _circle124, _path90, _circle125, _circle126, _path91, _circle127, _circle128, _path92, _polygon, _polygon2, _polygon3, _polygon4, _rect13, _circle129, _circle130, _path93, _circle131, _circle132, _path94, _circle133, _circle134, _path95, _circle135, _circle136, _path96, _circle137, _circle138, _path97, _circle139, _circle140, _path98, _circle141, _circle142, _path99, _circle143, _circle144, _path100, _circle145, _circle146, _path101, _circle147, _circle148, _path102, _circle149, _circle150, _path103, _circle151, _circle152, _path104, _circle153, _circle154, _path105, _circle155, _circle156, _path106, _circle157, _circle158, _path107, _text4, _g4, _rect14, _rect15, _rect16, _g5, _path108, _path109, _path110, _path111, _path112, _path113, _circle159, _circle160, _ellipse5, _ellipse6, _path114, _path115, _text5, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g6, _path127, _g7, _polygon5, _polygon6, _rect17, _circle161, _circle162, _g8, _path128, _path129, _path130, _path131, _path132, _rect18, _rect19, _rect20, _rect21, _path133;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b73a925f-84d4-42fb-b5d6-6e87d8bd3a11",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 877.58,
    height: 792,
    viewBox: "0 0 877.58 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a7708a18-1968-466f-aec8-942d54926793",
    x1: 375.25,
    y1: 786.7,
    x2: 375.25,
    y2: 259.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf316149-1642-4c35-912b-0526fb6ba35a",
    x1: 418.66,
    y1: 485.68,
    x2: 535.12,
    y2: 485.68,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2b8f177f-0bee-4351-92d2-383255bafedb",
    x1: 579.88,
    y1: 511.2,
    x2: 696.33,
    y2: 511.2,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5fa7eda4-28b9-4251-a6b9-2f9bae1ab28a",
    x1: 579.88,
    y1: 449.17,
    x2: 696.33,
    y2: 449.17,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed606ceb-ec5b-4ad4-aafb-d07a39889ee8",
    x1: 624.18,
    y1: 368.8,
    x2: 652.03,
    y2: 368.8,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5bdfa9af-64d8-4304-b0c9-c009dbcb0b09",
    x1: 418.66,
    y1: 640.11,
    x2: 460.44,
    y2: 640.11,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c8157e05-6c4d-459f-9f3d-940777b5c2cf",
    x1: 493.35,
    y1: 640.11,
    x2: 535.12,
    y2: 640.11,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcb9c466-4e4f-499b-b77e-2b1d8b8c75a7",
    x1: 624.18,
    y1: 358.04,
    x2: 652.03,
    y2: 358.04,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "76d7b266-3dc8-4483-9320-5920a3c94a7a",
    x1: 416.13,
    y1: 241.38,
    x2: 537.65,
    y2: 241.38,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd8d16db-b4e0-48b2-b556-c72431037b49",
    x1: 418.66,
    y1: 255.3,
    x2: 535.12,
    y2: 255.3,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9b7299fd-f428-4730-af99-5834ae02c1a5",
    x1: 593.77,
    y1: 269.19,
    x2: 695.53,
    y2: 269.19,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "259814f2-bace-4a84-846d-913a241e0e1e",
    x1: 593.77,
    y1: 267.92,
    x2: 695.53,
    y2: 267.92,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6bde5b34-751d-47bb-a52c-abe6c25985b5",
    x1: 529.42,
    y1: 255.3,
    x2: 539.55,
    y2: 255.3,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7ae729b-e046-481c-91f1-480616739e4e",
    x1: 414.23,
    y1: 255.3,
    x2: 424.36,
    y2: 255.3,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0a5f2a71-eaa7-4b0b-936b-346bcf386b7c",
    x1: 618.66,
    y1: 180.62,
    x2: 646.51,
    y2: 180.62,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6b03b853-b593-4e8c-a472-98ce3a1b668c",
    x1: 581.14,
    y1: 342.85,
    x2: 695.58,
    y2: 342.85,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2b55eef6-fdd3-4a74-987f-d0c0c6653b21",
    x1: 669.05,
    y1: 328.29,
    x2: 798.86,
    y2: 328.29,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "68add0c3-9d74-486a-8d51-bb09c445e216",
    x1: 307.28,
    y1: 180.62,
    x2: 335.12,
    y2: 180.62,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae767ea1-a40e-4088-ae9a-71e32fbfc886",
    x1: 477.35,
    y1: 328.29,
    x2: 607.15,
    y2: 328.29,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "78d047f2-2ee1-43b1-82dd-46479f60fdad",
    x1: 582.41,
    y1: 835.87,
    x2: 619.12,
    y2: 835.87,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "42ef2655-c6ab-480f-bcf3-ade3e1400c72",
    x1: 657.09,
    y1: 835.87,
    x2: 693.8,
    y2: 835.87,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5b17b9bb-3381-4a8e-8994-9de9247234c4",
    x1: 349.23,
    y1: 478.55,
    x2: 349.23,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3a7e078a-ec55-43e8-b09b-97c86482fcac",
    x1: 360.8,
    y1: 478.55,
    x2: 360.8,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "97e73ad9-bae7-4fde-8bad-bf58e410c32c",
    x1: 327.88,
    y1: 478.55,
    x2: 327.88,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0846014e-aadf-4752-9ea6-065f7b137900",
    x1: 343,
    y1: 468.46,
    x2: 343,
    y2: 460.46,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f5b5d668-4b46-47d4-8121-622234fcc291",
    x1: 366.58,
    y1: 470.09,
    x2: 366.58,
    y2: 462.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5221d1c1-0e53-493c-86d1-ab016ec74180",
    x1: 360.8,
    y1: 466.54,
    x2: 360.8,
    y2: 458.53,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dea28054-b72b-4fe1-8747-01fea83118a5",
    x1: 363.61,
    y1: 474.99,
    x2: 363.61,
    y2: 466.98,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "45b7d726-98cd-4a5b-a16e-9eddea340361",
    x1: 353.23,
    y1: 468.46,
    x2: 353.23,
    y2: 460.46,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff208e53-6d8c-45b4-9aad-d744664c752e",
    x1: 352.79,
    y1: 457.2,
    x2: 352.79,
    y2: 449.19,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "850b1ce3-a2fe-4ca6-be2b-781f37787b58",
    x1: 372.51,
    y1: 462.98,
    x2: 372.51,
    y2: 454.97,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "04ca35aa-840f-4821-b3ee-5f4af2d17fb6",
    x1: 370.58,
    y1: 470.54,
    x2: 370.58,
    y2: 462.53,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f6506291-4576-4c08-bb26-bc0182e7e66e",
    x1: 379.48,
    y1: 469.06,
    x2: 379.48,
    y2: 461.05,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a7aea1b1-0556-48e9-b0dd-01f9a02724fe",
    x1: 375.47,
    y1: 472.76,
    x2: 375.47,
    y2: 464.76,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1599d8c-de3f-4a60-afbc-8639da0049ee",
    x1: 348.79,
    y1: 462.98,
    x2: 348.79,
    y2: 454.97,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "03ccd1b2-2a36-4947-a0c6-62194e32b136",
    x1: 343,
    y1: 478.1,
    x2: 343,
    y2: 470.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d981f767-7791-4b13-a955-6010058dd1c2",
    x1: 333.96,
    y1: 478.55,
    x2: 333.96,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1a1fdb6a-181f-4b79-ab6e-8772347fae95",
    x1: 338.56,
    y1: 476.03,
    x2: 338.56,
    y2: 468.02,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4aa1838-35f4-4e47-a530-aa0f7db9a6a7",
    x1: 358.13,
    y1: 471.58,
    x2: 358.13,
    y2: 463.57,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4982e404-6c96-4815-af24-21fc8193caf9",
    x1: 358.13,
    y1: 462.09,
    x2: 358.13,
    y2: 454.08,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9c9fd0e1-0858-4547-850f-b4ece0fe5a9a",
    x1: 362.57,
    y1: 469.65,
    x2: 362.57,
    y2: 461.64,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f4790f8f-0389-47e4-bac2-12451da9aee1",
    x1: 358.57,
    y1: 454.53,
    x2: 358.57,
    y2: 446.52,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb45b416-7d41-4573-b6e7-8d6b47365053",
    x1: 359.46,
    y1: 458.53,
    x2: 359.46,
    y2: 450.52,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf108c31-387b-470b-b038-c3b82b804bb2",
    x1: 364.21,
    y1: 461.2,
    x2: 364.21,
    y2: 453.19,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "17ac4165-d33c-40b7-98d2-f7bd7c66df96",
    x1: 369.1,
    y1: 460.46,
    x2: 369.1,
    y2: 452.45,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9250565c-1552-4207-af45-d9e0ec5dfa27",
    x1: 367.76,
    y1: 464.46,
    x2: 367.76,
    y2: 456.45,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "95b75100-4961-4b63-b859-6405c7e5c677",
    x1: 351.01,
    y1: 459.27,
    x2: 351.01,
    y2: 451.27,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7ba180be-d187-4691-a6d5-edcb2f2fdbb8",
    x1: 339.45,
    y1: 471.43,
    x2: 339.45,
    y2: 463.42,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "43698e6b-9e6d-4c03-a071-38d6d2bc69f1",
    x1: 346.41,
    y1: 464.76,
    x2: 346.41,
    y2: 456.75,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "219b9869-f3c7-40fd-8808-74e3eb279a9a",
    x1: 332.18,
    y1: 476.17,
    x2: 332.18,
    y2: 468.17,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7172db46-f002-4bac-99d2-7e1c35c00965",
    x1: 370.58,
    y1: 473.06,
    x2: 370.58,
    y2: 465.05,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "015ebff1-2788-4e0a-a0f0-6f8e3672f6d4",
    x1: 352.64,
    y1: 450.52,
    x2: 352.64,
    y2: 442.52,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6bccdae5-7281-4508-ab31-3b9b6ef2a337",
    x1: 345.38,
    y1: 459.72,
    x2: 345.38,
    y2: 451.71,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e80207a7-71f5-4d42-908b-8e7375f8acd5",
    x1: 339.59,
    y1: 466.54,
    x2: 339.59,
    y2: 458.53,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "98756575-39b9-4896-9a6c-8dfabbdc08a6",
    x1: 343.75,
    y1: 474.1,
    x2: 343.75,
    y2: 466.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de22dcfc-c612-4520-a9ee-4f0a29e29c3f",
    x1: 349.38,
    y1: 469.06,
    x2: 349.38,
    y2: 461.05,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6b09d77b-c35c-4cab-9cd6-77230b8fffce",
    x1: 352.34,
    y1: 474.1,
    x2: 352.34,
    y2: 466.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "07b8c4e6-36b9-45b7-bcd4-f1aa2f23339c",
    x1: 383.03,
    y1: 478.55,
    x2: 383.03,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0df4fac5-2152-4729-8970-728c8474c1ea",
    x1: 377.4,
    y1: 477.66,
    x2: 377.4,
    y2: 469.65,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b825979b-c856-4539-bcb2-db34f1aa1079",
    x1: 366.58,
    y1: 478.1,
    x2: 366.58,
    y2: 470.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "92a4a20c-5b4e-440a-bbb2-e133d43a1f2d",
    x1: 354.57,
    y1: 478.55,
    x2: 354.57,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "21809c97-bcc6-448a-a25d-6857d446fb1c",
    x1: 353.38,
    y1: 462.53,
    x2: 353.38,
    y2: 454.53,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c02d2198-3ff5-476c-b2d4-915967592599",
    x1: 357.39,
    y1: 467.57,
    x2: 357.39,
    y2: 459.57,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a90820d-ffd1-4999-b6a6-b62d39c9a09b",
    x1: 350.71,
    y1: 455.27,
    x2: 350.71,
    y2: 447.26,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "884063dc-6581-479c-8add-ac3be09f6495",
    x1: 355.16,
    y1: 455.71,
    x2: 355.16,
    y2: 447.71,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3aadb8f9-666e-44d7-8850-101ab777324b",
    x1: 362.57,
    y1: 457.79,
    x2: 362.57,
    y2: 449.78,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8a24a864-6935-4c5d-9285-913af504c66f",
    x1: 342.56,
    y1: 464.31,
    x2: 342.56,
    y2: 456.31,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc6daa62-5d4c-4b0d-b132-80f8e3c8a1bb",
    x1: 345.38,
    y1: 469.5,
    x2: 345.38,
    y2: 461.5,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "10616889-139f-4dbb-a319-f69cc7e747c5",
    x1: 347.3,
    y1: 475.58,
    x2: 347.3,
    y2: 467.57,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d622a388-77b1-4bb5-b611-9789e59da2f2",
    x1: 358.57,
    y1: 473.65,
    x2: 358.57,
    y2: 465.65,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aba0b6cd-97d1-4fa6-b49c-03842d38332e",
    x1: 370.14,
    y1: 470.09,
    x2: 370.14,
    y2: 462.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5ca9418e-2b14-4da6-bfa5-c3bb69ced3c3",
    x1: 373.84,
    y1: 466.98,
    x2: 373.84,
    y2: 458.98,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "676912ef-31ab-495b-b41f-eacc4c968bb5",
    x1: 379.62,
    y1: 474.1,
    x2: 379.62,
    y2: 466.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d653a025-b5bb-4bff-a013-e6012a1b50df",
    x1: 360.94,
    y1: 478.99,
    x2: 360.94,
    y2: 470.98,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "69076bc3-909d-469f-9f3d-2c2fc4fb7896",
    x1: 340.34,
    y1: 477.21,
    x2: 340.34,
    y2: 469.21,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e21f1f9-2811-485c-b403-d55dfb297082",
    x1: 334.55,
    y1: 472.02,
    x2: 334.55,
    y2: 464.02,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7b332ac6-e439-4d8e-b49b-3940eac480ec",
    x1: 342.11,
    y1: 469.5,
    x2: 342.11,
    y2: 461.5,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8a64d9b2-e5fa-4ff9-b7f2-7551348d69a8",
    x1: 337.96,
    y1: 463.42,
    x2: 337.96,
    y2: 455.42,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c02cfaa7-e5bb-4529-a018-becb6edff9e0",
    x1: 341.52,
    y1: 457.79,
    x2: 341.52,
    y2: 449.78,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1adc4b7e-2266-4120-9a2c-b1ee45f93a38",
    x1: 372.51,
    y1: 478.55,
    x2: 372.51,
    y2: 470.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0795952b-89fa-4d91-9b87-264086ebf15d",
    x1: 355.98,
    y1: 540.67,
    x2: 355.98,
    y2: 474.54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e195c42c-b3fa-428e-a6c2-bba40b68f175",
    x1: 335.89,
    y1: 467.57,
    x2: 335.89,
    y2: 459.57,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7ce678f8-f7f8-4e84-9755-f16c000a5f68",
    x1: 345.97,
    y1: 456.31,
    x2: 345.97,
    y2: 448.3,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3b59fc91-8ed7-45d4-a55f-b7cd94fa4927",
    x1: 331.88,
    y1: 473.65,
    x2: 331.88,
    y2: 465.65,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "27db5171-e4a6-4c23-bbce-6aa5a76b2996",
    x1: 327.09,
    y1: 446.46,
    x2: 327.09,
    y2: 438.45,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0249779b-e172-4f2c-bc04-7c0ea3dc82da",
    x1: 343.93,
    y1: 423.52,
    x2: 343.93,
    y2: 415.51,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8c79d8d6-8823-4951-aba4-5a7a6f2c3a58",
    x1: 358.45,
    y1: 406.1,
    x2: 358.45,
    y2: 398.09,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7795da92-9f14-4819-a547-b8a7b14d0f76",
    x1: 386.62,
    y1: 443.56,
    x2: 386.62,
    y2: 435.55,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdf0b6a6-0933-42ca-a691-eb2c3d31370e",
    x1: 408.98,
    y1: 472.01,
    x2: 408.98,
    y2: 464.01,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "19d358ce-d419-48e7-8d0d-9cc1ca4b52b3",
    x1: 325.93,
    y1: 541.41,
    x2: 325.93,
    y2: 533.41,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb844668-b85d-4994-a071-4f4811cb4197",
    x1: 320.41,
    y1: 534.15,
    x2: 320.41,
    y2: 526.15,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d3ce0fc7-ecf4-4243-94a7-e2b842d9cf5c",
    x1: 316.92,
    y1: 494.95,
    x2: 316.92,
    y2: 486.95,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f3cd359-6fc0-4598-8206-402359b2f73e",
    x1: 392.42,
    y1: 538.22,
    x2: 392.42,
    y2: 530.21,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6037da8c-05f4-404a-bd66-d108e4c067bf",
    x1: 399.68,
    y1: 533.57,
    x2: 399.68,
    y2: 525.57,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af7b7254-cc98-45fd-8632-1da35d19935d",
    x1: 400.55,
    y1: 539.09,
    x2: 400.55,
    y2: 531.08,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "47b45e98-f2fc-4393-9279-4f14e53f125e",
    x1: 385.45,
    y1: 539.09,
    x2: 385.45,
    y2: 531.08,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "569c99fc-09ad-4de9-aa6f-12061deb3b46",
    x1: 836.45,
    y1: 810.56,
    x2: 836.45,
    y2: 274.01,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae5f3eae-4eb6-4770-bfe2-0c740001d1d9",
    x1: 755.6,
    y1: 515.3,
    x2: 755.6,
    y2: 471.69,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "9173947b-3e82-482d-9aac-5eef3c2c1e15",
    transform: "translate(-161.21 -54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "45f25496-3b42-488f-bca3-f39eddf5d524",
    "data-name": "<Clipping Path>",
    d: "M769.91,477.6,768,473.06l-24.9,10.23a3.07,3.07,0,0,0-1.91,2.84V513h4.92V487.36Z",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6d82e1f1-f898-4ccf-abdb-ac811c1cde0e",
    x1: 583.48,
    y1: 539.94,
    x2: 583.48,
    y2: 454.34,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "62368fd5-dc9d-409d-ac85-527288a57f36",
    x1: 583.37,
    y1: 507.31,
    x2: 583.37,
    y2: 480.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "94a3214b-e7fc-44ad-82af-79045aa80b8c",
    x1: 816.05,
    y1: 258,
    x2: 816.05,
    y2: 54,
    xlinkHref: "#a7708a18-1968-466f-aec8-942d54926793"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fans") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.72,350.29H799.86a26.1,26.1,0,0,1,26.1,26.1V635.45a0,0,0,0,1,0,0H51.62a0,0,0,0,1,0,0V376.39A26.1,26.1,0,0,1,77.72,350.29Z",
    fill: "#535461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.71,492.87H83.54A12.33,12.33,0,0,1,95.87,505.2V635.45a0,0,0,0,1,0,0H15.37a8,8,0,0,1-8-8V505.2A12.33,12.33,0,0,1,19.71,492.87Z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33,492.87H76.16A12.33,12.33,0,0,1,88.5,505.2V635.45a0,0,0,0,1,0,0H8a8,8,0,0,1-8-8V505.2A12.33,12.33,0,0,1,12.33,492.87Z",
    fill: "#535461"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M950.92,546.87h80.5a0,0,0,0,1,0,0V677.11a12.33,12.33,0,0,1-12.33,12.33H955.25a12.33,12.33,0,0,1-12.33-12.33V554.87A8,8,0,0,1,950.92,546.87Z",
    transform: "translate(1813.12 1182.32) rotate(-180)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M958.29,546.87h80.5a0,0,0,0,1,0,0V677.11a12.33,12.33,0,0,1-12.33,12.33H962.63a12.33,12.33,0,0,1-12.33-12.33V554.87a8,8,0,0,1,8-8Z",
    transform: "translate(1827.87 1182.32) rotate(-180)",
    fill: "#535461"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.34,538.35h662.9a18.84,18.84,0,0,1,18.84,18.84v78.26a0,0,0,0,1,0,0H88.5a0,0,0,0,1,0,0V557.19A18.84,18.84,0,0,1,107.34,538.35Z",
    fill: "#535461"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.34,538.35h662.9a18.84,18.84,0,0,1,18.84,18.84v78.26a0,0,0,0,1,0,0H88.5a0,0,0,0,1,0,0V557.19A18.84,18.84,0,0,1,107.34,538.35Z",
    opacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 635.45,
    width: 27.04,
    height: 28.27,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 635.45,
    width: 27.04,
    height: 28.27,
    opacity: 0.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 635.45,
    width: 27.04,
    height: 1.23,
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 973.65,
    y: 689.45,
    width: 27.04,
    height: 28.27,
    transform: "translate(1813.12 1353.16) rotate(-180)",
    fill: "#535461"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 973.65,
    y: 689.45,
    width: 27.04,
    height: 28.27,
    transform: "translate(1813.12 1353.16) rotate(-180)",
    opacity: 0.15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 973.65,
    y: 689.45,
    width: 27.04,
    height: 1.23,
    transform: "translate(1813.12 1326.12) rotate(-180)",
    opacity: 0.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(204.28 454.85)",
    opacity: 0.7,
    fontSize: 38.32,
    fontFamily: "Lato-Light, Lato"
  }, "1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,567.65l-4-.75,7.95-29.31c12.52-93.93-34.79-103.39-52.53-103.71a58.34,58.34,0,0,0-6.23-1.89V420.91A58.81,58.81,0,0,0,433,373.42h.15c2.82,0,5.11-4.29,5.11-9.58a13.3,13.3,0,0,0-2.22-7.9q.3-3,.31-6.15a61.12,61.12,0,0,0-18.9-44.25,39.4,39.4,0,0,0-4.34-11.67c-4.35-7.67-11.6-15.67-8.65-24l-19.13,2-.18-12.6c-6,1.07-8.47,8-12,12.92-8.52,11.85-25.61,13.5-36.92,22.73-3.84,3.14-12.49,12.68-10.85,18.94a61,61,0,0,0-11.67,36q0,3.11.31,6.15a13.3,13.3,0,0,0-2.22,7.9c0,5.29,2.29,9.58,5.11,9.58h.15A58.81,58.81,0,0,0,361,420.91V432a58.34,58.34,0,0,0-6.23,1.89c-17.74.32-65.05,9.78-52.53,103.71l7.95,29.31-1.89.35a21.8,21.8,0,0,0-17.43,25.43l31.36,168a6.6,6.6,0,0,0,7.7,5.28l5.53-1v3.27a18.35,18.35,0,0,0-10.22,16.44v2.08h37v-2.08a18.34,18.34,0,0,0-8.94-15.74v-7.31l5.05-.94a6.6,6.6,0,0,0,5.28-7.7L334.21,595.08h81.71L386.46,752.93a6.6,6.6,0,0,0,5.28,7.7l5.05.94v7.31a18.34,18.34,0,0,0-8.94,15.74v2.08h37v-2.08a18.35,18.35,0,0,0-10.22-16.44v-3.27l5.53,1a6.6,6.6,0,0,0,7.7-5.28l31.76-170.13A19.62,19.62,0,0,0,444,567.65Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#a7708a18-1968-466f-aec8-942d54926793)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 175.76,
    y: 689.53,
    width: 17.21,
    height: 23.35,
    fill: "#fdb797"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 234.76,
    y: 689.53,
    width: 17.21,
    height: 23.35,
    fill: "#fdb797"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 157.32,
    y: 497.79,
    width: 113.08,
    height: 40.56,
    fill: "#4d8af0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.32,
    y: 497.79,
    width: 113.08,
    height: 40.56
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.54,559.16S360.73,569,375.07,569s56.54-9.83,56.54-9.83V553H318.54Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M431.61,557.93s-42.19,9.83-56.54,9.83-56.54-9.83-56.54-9.83v-67.6a56.54,56.54,0,0,1,56.54-56.54h0a56.54,56.54,0,0,1,56.54,56.54Z",
    transform: "translate(-161.21 -54)",
    fill: "#f55f44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200.34,351.52h27a0,0,0,0,1,0,0v33.25a11,11,0,0,1-11,11h-5a11,11,0,0,1-11-11V351.52a0,0,0,0,1,0,0Z",
    fill: "#fdb797"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2,751.42,330.49,757a5.17,5.17,0,0,1-6-4.13L293.36,586.2A17.06,17.06,0,0,1,307,566.29l18-3.36a5.17,5.17,0,0,1,6,4.13l33.29,178.33A5.17,5.17,0,0,1,360.2,751.42Z",
    transform: "translate(-161.21 -54)",
    fill: "#4d8af0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M389.95,751.42,419.66,757a5.17,5.17,0,0,0,6-4.13L457.1,584.52a15.36,15.36,0,0,0-12.28-17.91l-19.7-3.68a5.17,5.17,0,0,0-6,4.13L385.82,745.39A5.17,5.17,0,0,0,389.95,751.42Z",
    transform: "translate(-161.21 -54)",
    fill: "#4d8af0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M361.55,426a56.58,56.58,0,0,0,27,0V406.75h-27Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.86,
    cy: 302.36,
    r: 59,
    fill: "#333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.86,
    cy: 315.88,
    r: 56.54,
    fill: "#fdb797"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.74,303.54c10.88-8.88,27.33-10.46,35.52-21.86,3.41-4.74,5.81-11.39,11.56-12.43l.17,12.13,18.41-1.89c-2.84,8,4.13,15.69,8.32,23.08a38,38,0,0,1,4.91,17.86c-6.39,3.84-14.31-.35-21.43-2.58-6.91-2.17-14.27-2.39-21.51-2.6a44.7,44.7,0,0,0-11.1.61,56,56,0,0,0-9.16,3.37c-4.9,2-20.35,9.79-24.9,4.8C323.36,318.36,333.55,307,337.74,303.54Z",
    transform: "translate(-161.21 -54)",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M340.82,341.53a25.93,25.93,0,0,0,10,3,88.08,88.08,0,0,0,42.91-4.82c2.24,5.68,7.71,9.58,13.52,11.43s12,1.95,18.12,2a6.71,6.71,0,0,0,3.9-.75c2.72-1.84,1.4-6-.18-8.91l-7.88-14.28c-2.33-4.22-4.72-8.52-8.33-11.72-4.52-4-10.52-5.87-16.44-7.06a92.7,92.7,0,0,0-42.19,1.41C339.54,315.85,320.63,329.31,340.82,341.53Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340.82,340.3a25.93,25.93,0,0,0,10,3,88.08,88.08,0,0,0,42.91-4.82c2.24,5.68,7.71,9.58,13.52,11.43s12,1.95,18.12,2a6.71,6.71,0,0,0,3.9-.75c2.72-1.84,1.4-6-.18-8.91L421.22,328c-2.33-4.22-4.72-8.52-8.33-11.72-4.52-4-10.52-5.87-16.44-7.06a92.7,92.7,0,0,0-42.19,1.41C339.54,314.62,320.63,328.08,340.82,340.3Z",
    transform: "translate(-161.21 -54)",
    fill: "#333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.79,
    cy: 315.88,
    rx: 4.92,
    ry: 9.22,
    fill: "#fdb797"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.94,
    cy: 315.88,
    rx: 4.92,
    ry: 9.22,
    fill: "#fdb797"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.78,437.56S290.27,426.42,305,537l8.6,31.71,24.59-1s-16-36.87-6.15-61.46S361.78,437.56,361.78,437.56Z",
    transform: "translate(-161.21 -54)",
    fill: "#f55f44"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M388.37,437.56s71.52-11.14,56.77,99.48l-8.6,31.71-24.59-1s16-36.87,6.15-61.46S388.37,437.56,388.37,437.56Z",
    transform: "translate(-161.21 -54)",
    fill: "#f55f44"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.93,
    cy: 518.68,
    r: 13.52,
    fill: "#fdb797"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.26,
    cy: 518.68,
    r: 13.52,
    fill: "#fdb797"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.3,703h6.89a14.37,14.37,0,0,1,14.37,14.37v5.29a0,0,0,0,1,0,0H165.93a0,0,0,0,1,0,0v-5.29A14.37,14.37,0,0,1,180.3,703Z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240.53,703h6.89a14.37,14.37,0,0,1,14.37,14.37v5.29a0,0,0,0,1,0,0H226.15a0,0,0,0,1,0,0v-5.29A14.37,14.37,0,0,1,240.53,703Z",
    fill: "#333"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(204.65 455.38)",
    fontSize: 36.87,
    fill: "#fff",
    fontFamily: "Lato-Light, Lato"
  }, "1")), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M330.83,496.48s-4.92,25.81,3.69,36.87",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M419.32,496.48s4.92,25.81-3.69,36.87",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.66,
    y: 442.64,
    width: 116.45,
    height: 86.07,
    fill: "url(#cf316149-1642-4c35-912b-0526fb6ba35a)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.88,519.43s43.45,5.06,58.23,5.06,58.23-5.06,58.23-5.06V497.91H579.88Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#2b8f177f-0bee-4351-92d2-383255bafedb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M696.33,518.16s-43.45,5.06-58.23,5.06-58.23-5.06-58.23-5.06V433.35a58.23,58.23,0,0,1,58.23-58.23h0a58.23,58.23,0,0,1,58.23,58.23Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#5fa7eda4-28b9-4251-a6b9-2f9bae1ab28a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,391.58h-5.85a11,11,0,0,1-11-11V346H652v34.57A11,11,0,0,1,641,391.58Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#ed606ceb-ec5b-4ad4-aafb-d07a39889ee8)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.66,
    y: 498.34,
    width: 41.77,
    height: 283.54,
    fill: "url(#5bdfa9af-64d8-4304-b0c9-c009dbcb0b09)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.35,
    y: 498.34,
    width: 41.77,
    height: 283.54,
    fill: "url(#c8157e05-6c4d-459f-9f3d-940777b5c2cf)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.18,367.11a58.26,58.26,0,0,0,27.85,0V347.28H624.18Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#fcb9c466-4e4f-499b-b77e-2b1d8b8c75a7)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 476.89,
    cy: 241.38,
    r: 60.76,
    fill: "url(#76d7b266-3dc8-4483-9320-5920a3c94a7a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.89,
    cy: 255.3,
    r: 58.23,
    fill: "url(#fd8d16db-b4e0-48b2-b556-c72431037b49)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.82,280.11c3.09,1.87,6.72,2.61,10.3,3.1a90.71,90.71,0,0,0,44.19-5c2.31,5.85,7.94,9.87,13.93,11.77s12.38,2,18.67,2.08a6.91,6.91,0,0,0,4-.77c2.8-1.89,1.45-6.22-.19-9.18l-8.11-14.71c-2.4-4.34-4.86-8.78-8.58-12.07-4.65-4.12-10.83-6-16.93-7.27a95.46,95.46,0,0,0-43.45,1.45C601.51,253.66,582,267.53,602.82,280.11Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#9b7299fd-f428-4730-af99-5834ae02c1a5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M602.82,278.84c3.09,1.87,6.72,2.61,10.3,3.1a90.71,90.71,0,0,0,44.19-5c2.31,5.85,7.94,9.87,13.93,11.77s12.38,2,18.67,2.08a6.91,6.91,0,0,0,4-.77c2.8-1.89,1.45-6.22-.19-9.18l-8.11-14.71c-2.4-4.34-4.86-8.78-8.58-12.07-4.65-4.12-10.83-6-16.93-7.27a95.46,95.46,0,0,0-43.45,1.45C601.51,252.39,582,266.26,602.82,278.84Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#259814f2-bace-4a84-846d-913a241e0e1e)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 534.48,
    cy: 255.3,
    rx: 5.06,
    ry: 9.49,
    fill: "url(#6bde5b34-751d-47bb-a52c-abe6c25985b5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.3,
    cy: 255.3,
    rx: 5.06,
    ry: 9.49,
    fill: "url(#e7ae729b-e046-481c-91f1-480616739e4e)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632.58,
    cy: 180.62,
    r: 13.92,
    fill: "url(#0a5f2a71-eaa7-4b0b-936b-346bcf386b7c)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(454.87 395.17)",
    fontSize: 37.97,
    fontFamily: "Lato-Light, Lato"
  }, "00"), /*#__PURE__*/React.createElement("path", {
    d: "M639.37,332.09s-32.91,11.39-58.23-13.92c0,0,2,8.39,5.57,18.51a58.23,58.23,0,0,0,108.88-18.1C689.66,321.86,646.41,342.65,639.37,332.09Zm-1.27,15.19c-6.29,0-11.39-4.8-11.39-7.59s5.1-2.53,11.39-2.53,11.39-.26,11.39,2.53S644.39,347.28,638.1,347.28Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#6b03b853-b593-4e8c-a472-98ce3a1b668c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.05,384s67.78-38,109.55-149.42l20.25,12.66S765.31,389.22,681.14,422Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#2b55eef6-fdd3-4a74-987f-d0c0c6653b21)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.2,
    cy: 180.62,
    r: 13.92,
    fill: "url(#68add0c3-9d74-486a-8d51-bb09c445e216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.15,384S539.37,346,497.6,234.62l-20.25,12.66S510.89,389.22,595.07,422Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#ae767ea1-a40e-4088-ae9a-71e32fbfc886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.12,846H582.41v-5.88a14.38,14.38,0,0,1,14.38-14.37h8a14.38,14.38,0,0,1,14.38,14.38Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#78d047f2-2ee1-43b1-82dd-46479f60fdad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.8,846H657.09v-5.88a14.37,14.37,0,0,1,14.38-14.37h8a14.37,14.37,0,0,1,14.38,14.38Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#42ef2655-c6ab-480f-bcf3-ade3e1400c72)"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 420.35,
    y: 443.71,
    width: 113.08,
    height: 83.58,
    fill: "#4d8af0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M581.56,519.83s42.19,4.92,56.54,4.92,56.54-4.92,56.54-4.92V498.93H581.56Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M694.64,518.6s-42.19,4.92-56.54,4.92-56.54-4.92-56.54-4.92V436.25a56.54,56.54,0,0,1,56.54-56.54h0a56.54,56.54,0,0,1,56.54,56.54Z",
    transform: "translate(-161.21 -54)",
    fill: "#ff9100"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M463.37,297.44h27a0,0,0,0,1,0,0v33.25a11,11,0,0,1-11,11h-5a11,11,0,0,1-11-11V297.44A0,0,0,0,1,463.37,297.44Z",
    fill: "#fdb797"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 420.35,
    y: 497.79,
    width: 40.56,
    height: 275.32,
    fill: "#4d8af0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 492.87,
    y: 497.79,
    width: 40.56,
    height: 275.32,
    fill: "#4d8af0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M624.58,371.93a56.58,56.58,0,0,0,27,0V352.67h-27Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 476.89,
    cy: 248.28,
    r: 59,
    fill: "#814e4d"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 476.89,
    cy: 261.8,
    r: 56.54,
    fill: "#fdb797"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M603.84,287.45a25.93,25.93,0,0,0,10,3,88.08,88.08,0,0,0,42.91-4.82c2.24,5.68,7.71,9.58,13.52,11.43s12,1.95,18.12,2a6.71,6.71,0,0,0,3.9-.75c2.72-1.84,1.4-6-.18-8.91l-7.88-14.28c-2.33-4.22-4.72-8.52-8.33-11.72-4.52-4-10.52-5.87-16.44-7.06a92.7,92.7,0,0,0-42.19,1.41C602.57,261.76,583.66,275.23,603.84,287.45Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M603.84,286.22a25.93,25.93,0,0,0,10,3,88.08,88.08,0,0,0,42.91-4.82c2.24,5.68,7.71,9.58,13.52,11.43s12,1.95,18.12,2a6.71,6.71,0,0,0,3.9-.75c2.72-1.84,1.4-6-.18-8.91l-7.88-14.28c-2.33-4.22-4.72-8.52-8.33-11.72-4.52-4-10.52-5.87-16.44-7.06a92.7,92.7,0,0,0-42.19,1.41C602.57,260.54,583.66,274,603.84,286.22Z",
    transform: "translate(-161.21 -54)",
    fill: "#814e4d"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.82,
    cy: 261.8,
    rx: 4.92,
    ry: 9.22,
    fill: "#fdb797"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.97,
    cy: 261.8,
    rx: 4.92,
    ry: 9.22,
    fill: "#fdb797"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.07,
    cy: 189.28,
    r: 13.52,
    fill: "#fdb797"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(455.51 397.62)",
    fontSize: 36.87,
    fill: "#fff",
    fontFamily: "Lato-Light, Lato"
  }, "00")), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M639.33,337.92s-32,11.06-56.54-13.52c0,0,2,8.15,5.4,18a56.54,56.54,0,0,0,105.72-17.57C688.17,328,646.17,348.18,639.33,337.92Zm-1.23,14.75C632,352.67,627,348,627,345.3s5-2.46,11.06-2.46,11.06-.26,11.06,2.46S644.21,352.67,638.1,352.67Z",
    transform: "translate(-161.21 -54)",
    fill: "#814e4d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M668.15,388.37S734,351.44,774.53,243.28l19.67,12.29S761.63,393.4,679.89,425.19Z",
    transform: "translate(-161.21 -54)",
    fill: "#ff9100"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.71,
    cy: 189.28,
    r: 13.52,
    fill: "#fdb797"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M608,388.37s-65.82-36.93-106.38-145.09L482,255.57S514.58,393.4,596.31,425.19Z",
    transform: "translate(-161.21 -54)",
    fill: "#ff9100"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M437.19,763.27h6.89a14.37,14.37,0,0,1,14.37,14.37v5.29a0,0,0,0,1,0,0H422.81a0,0,0,0,1,0,0v-5.29A14.37,14.37,0,0,1,437.19,763.27Z",
    fill: "#333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M509.7,763.27h6.89A14.37,14.37,0,0,1,531,777.65v5.29a0,0,0,0,1,0,0H495.33a0,0,0,0,1,0,0v-5.29A14.37,14.37,0,0,1,509.7,763.27Z",
    fill: "#333"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.23,
    cy: 474.54,
    r: 4,
    fill: "url(#5b17b9bb-3381-4a8e-8994-9de9247234c4)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.23,
    cy: 474.54,
    r: 3.56,
    fill: "#fdd835"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M507.77,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,507.77,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.8,
    cy: 474.54,
    r: 4,
    fill: "url(#3a7e078a-ec55-43e8-b09b-97c86482fcac)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.8,
    cy: 474.54,
    r: 3.56,
    fill: "#fdd835"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M519.34,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,519.34,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.88,
    cy: 474.54,
    r: 4,
    fill: "url(#97e73ad9-bae7-4fde-8bad-bf58e410c32c)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.88,
    cy: 474.54,
    r: 3.56,
    fill: "#fdd835"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M486.42,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,486.42,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 464.46,
    r: 4,
    fill: "url(#0846014e-aadf-4752-9ea6-065f7b137900)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 464.46,
    r: 3.56,
    fill: "#fdd835"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M501.55,519.5a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,501.55,519.5Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.58,
    cy: 466.09,
    r: 4,
    fill: "url(#f5b5d668-4b46-47d4-8121-622234fcc291)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.58,
    cy: 466.09,
    r: 3.56,
    fill: "#fdd835"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M525.12,521.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,525.12,521.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.8,
    cy: 462.53,
    r: 4,
    fill: "url(#5221d1c1-0e53-493c-86d1-ab016ec74180)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.8,
    cy: 462.53,
    r: 3.56,
    fill: "#fdd835"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M519.34,517.57a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,519.34,517.57Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.61,
    cy: 470.98,
    r: 4,
    fill: "url(#dea28054-b72b-4fe1-8747-01fea83118a5)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.61,
    cy: 470.98,
    r: 3.56,
    fill: "#fdd835"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M522.15,526a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,522.15,526Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.23,
    cy: 464.46,
    r: 4,
    fill: "url(#45b7d726-98cd-4a5b-a16e-9eddea340361)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.23,
    cy: 464.46,
    r: 3.56,
    fill: "#fdd835"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M511.78,519.5a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,511.78,519.5Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.79,
    cy: 453.19,
    r: 4,
    fill: "url(#ff208e53-6d8c-45b4-9aad-d744664c752e)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.79,
    cy: 453.19,
    r: 3.56,
    fill: "#fdd835"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M511.33,508.23a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,511.33,508.23Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.51,
    cy: 458.98,
    r: 4,
    fill: "url(#850b1ce3-a2fe-4ca6-be2b-781f37787b58)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.51,
    cy: 458.98,
    r: 3.56,
    fill: "#fdd835"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M531.05,514a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,531.05,514Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 466.54,
    r: 4,
    fill: "url(#04ca35aa-840f-4821-b3ee-5f4af2d17fb6)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 466.54,
    r: 3.56,
    fill: "#fdd835"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M529.12,521.57a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,529.12,521.57Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.48,
    cy: 465.05,
    r: 4,
    fill: "url(#f6506291-4576-4c08-bb26-bc0182e7e66e)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.48,
    cy: 465.05,
    r: 3.56,
    fill: "#fdd835"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M538,520.09a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,538,520.09Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.47,
    cy: 468.76,
    r: 4,
    fill: "url(#a7aea1b1-0556-48e9-b0dd-01f9a02724fe)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.47,
    cy: 468.76,
    r: 3.56,
    fill: "#fdd835"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M534,523.8a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,534,523.8Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.79,
    cy: 458.98,
    r: 4,
    fill: "url(#f1599d8c-de3f-4a60-afbc-8639da0049ee)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.79,
    cy: 458.98,
    r: 3.56,
    fill: "#fdd835"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M507.33,514a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,507.33,514Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 474.1,
    r: 4,
    fill: "url(#03ccd1b2-2a36-4947-a0c6-62194e32b136)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 474.1,
    r: 3.56,
    fill: "#fbc02d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M501.55,529.14a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,501.55,529.14Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.96,
    cy: 474.54,
    r: 4,
    fill: "url(#d981f767-7791-4b13-a955-6010058dd1c2)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.96,
    cy: 474.54,
    r: 3.56,
    fill: "#fbc02d"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M492.5,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,492.5,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.56,
    cy: 472.02,
    r: 4,
    fill: "url(#1a1fdb6a-181f-4b79-ab6e-8772347fae95)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.56,
    cy: 472.02,
    r: 3.56,
    fill: "#fbc02d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M497.1,527.06a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,497.1,527.06Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.13,
    cy: 467.57,
    r: 4,
    fill: "url(#b4aa1838-35f4-4e47-a530-aa0f7db9a6a7)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.13,
    cy: 467.57,
    r: 3.56,
    fill: "#fbc02d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M516.67,522.61a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,516.67,522.61Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.13,
    cy: 458.09,
    r: 4,
    fill: "url(#4982e404-6c96-4815-af24-21fc8193caf9)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.13,
    cy: 458.09,
    r: 3.56,
    fill: "#fbc02d"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M516.67,513.12a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,516.67,513.12Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.57,
    cy: 465.65,
    r: 4,
    fill: "url(#9c9fd0e1-0858-4547-850f-b4ece0fe5a9a)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.57,
    cy: 465.65,
    r: 3.56,
    fill: "#fbc02d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M521.12,520.68a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,521.12,520.68Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.57,
    cy: 450.52,
    r: 4,
    fill: "url(#f4790f8f-0389-47e4-bac2-12451da9aee1)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.57,
    cy: 450.52,
    r: 3.56,
    fill: "#fbc02d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M517.11,505.56a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,517.11,505.56Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.46,
    cy: 454.53,
    r: 4,
    fill: "url(#cb45b416-7d41-4573-b6e7-8d6b47365053)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.46,
    cy: 454.53,
    r: 3.56,
    fill: "#fbc02d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M518,509.57a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,518,509.57Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.21,
    cy: 457.2,
    r: 4,
    fill: "url(#cf108c31-387b-470b-b038-c3b82b804bb2)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.21,
    cy: 457.2,
    r: 3.56,
    fill: "#fbc02d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M522.75,512.23a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,522.75,512.23Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.1,
    cy: 456.45,
    r: 4,
    fill: "url(#17ac4165-d33c-40b7-98d2-f7bd7c66df96)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.1,
    cy: 456.45,
    r: 3.56,
    fill: "#fbc02d"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M527.64,511.49a3.56,3.56,0,0,1,6-2.55A3.56,3.56,0,1,0,528,513,3.54,3.54,0,0,1,527.64,511.49Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.76,
    cy: 460.46,
    r: 4,
    fill: "url(#9250565c-1552-4207-af45-d9e0ec5dfa27)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.76,
    cy: 460.46,
    r: 3.56,
    fill: "#fbc02d"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M526.31,515.5a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,526.31,515.5Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.01,
    cy: 455.27,
    r: 4,
    fill: "url(#95b75100-4961-4b63-b859-6405c7e5c677)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.01,
    cy: 455.27,
    r: 3.56,
    fill: "#fbc02d"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M509.55,510.31a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,509.55,510.31Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.45,
    cy: 467.43,
    r: 4,
    fill: "url(#7ba180be-d187-4691-a6d5-edcb2f2fdbb8)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.45,
    cy: 467.43,
    r: 3.56,
    fill: "#fbc02d"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M498,522.46a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,498,522.46Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.41,
    cy: 460.75,
    r: 4,
    fill: "url(#43698e6b-9e6d-4c03-a071-38d6d2bc69f1)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.41,
    cy: 460.75,
    r: 3.56,
    fill: "#fbc02d"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M505,515.79a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,505,515.79Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.18,
    cy: 472.17,
    r: 4,
    fill: "url(#219b9869-f3c7-40fd-8808-74e3eb279a9a)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.18,
    cy: 472.17,
    r: 3.56,
    fill: "#fbc02d"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M490.72,527.21a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,490.72,527.21Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 469.06,
    r: 4,
    fill: "url(#7172db46-f002-4bac-99d2-7e1c35c00965)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 469.06,
    r: 3.56,
    fill: "#fbc02d"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M529.12,524.09a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,529.12,524.09Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.64,
    cy: 446.52,
    r: 4,
    fill: "url(#015ebff1-2788-4e0a-a0f0-6f8e3672f6d4)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.64,
    cy: 446.52,
    r: 3.56,
    fill: "#fbc02d"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M511.18,501.56a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,511.18,501.56Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 455.71,
    r: 4,
    fill: "url(#6bccdae5-7281-4508-ab31-3b9b6ef2a337)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 455.71,
    r: 3.56,
    fill: "#fbc02d"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M503.92,510.75a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,503.92,510.75Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59,
    cy: 462.53,
    r: 4,
    fill: "url(#e80207a7-71f5-4d42-908b-8e7375f8acd5)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59,
    cy: 462.53,
    r: 3.56,
    fill: "#fbc02d"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M498.14,517.57a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,498.14,517.57Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.75,
    cy: 470.09,
    r: 4,
    fill: "url(#98756575-39b9-4896-9a6c-8dfabbdc08a6)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.75,
    cy: 470.09,
    r: 3.56,
    fill: "#fbc02d"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M502.29,525.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,502.29,525.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.38,
    cy: 465.05,
    r: 4,
    fill: "url(#de22dcfc-c612-4520-a9ee-4f0a29e29c3f)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.38,
    cy: 465.05,
    r: 3.56,
    fill: "#fbc02d"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M507.92,520.09a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,507.92,520.09Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.34,
    cy: 470.09,
    r: 4,
    fill: "url(#6b09d77b-c35c-4cab-9cd6-77230b8fffce)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.34,
    cy: 470.09,
    r: 3.56,
    fill: "#fbc02d"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M510.89,525.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,510.89,525.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.03,
    cy: 474.54,
    r: 4,
    fill: "url(#07b8c4e6-36b9-45b7-bcd4-f1aa2f23339c)"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.03,
    cy: 474.54,
    r: 3.56,
    fill: "#fbc02d"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M541.58,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,541.58,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.4,
    cy: 473.65,
    r: 4,
    fill: "url(#0df4fac5-2152-4729-8970-728c8474c1ea)"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.4,
    cy: 473.65,
    r: 3.56,
    fill: "#fbc02d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M535.94,528.69a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,535.94,528.69Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.58,
    cy: 474.1,
    r: 4,
    fill: "url(#b825979b-c856-4539-bcb2-db34f1aa1079)"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.58,
    cy: 474.1,
    r: 3.56,
    fill: "#fbc02d"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.32,
    cy: 469.95,
    r: 3.56,
    fill: "#fbc02d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M525.12,529.14a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,525.12,529.14Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.57,
    cy: 474.54,
    r: 4,
    fill: "url(#92a4a20c-5b4e-440a-bbb2-e133d43a1f2d)"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.57,
    cy: 474.54,
    r: 3.56,
    fill: "#fbc02d"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M513.11,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,513.11,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.38,
    cy: 458.53,
    r: 4,
    fill: "url(#21809c97-bcc6-448a-a25d-6857d446fb1c)"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.38,
    cy: 458.53,
    r: 3.56,
    fill: "#fdd835"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M511.92,513.57a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,511.92,513.57Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.39,
    cy: 463.57,
    r: 4,
    fill: "url(#c02d2198-3ff5-476c-b2d4-915967592599)"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.39,
    cy: 463.57,
    r: 3.56,
    fill: "#fdd835"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M515.93,518.61a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,515.93,518.61Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.71,
    cy: 451.27,
    r: 4,
    fill: "url(#9a90820d-ffd1-4999-b6a6-b62d39c9a09b)"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.71,
    cy: 451.27,
    r: 3.56,
    fill: "#fdd835"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M509.26,506.3a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,509.26,506.3Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.16,
    cy: 451.71,
    r: 4,
    fill: "url(#884063dc-6581-479c-8add-ac3be09f6495)"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.16,
    cy: 451.71,
    r: 3.56,
    fill: "#fdd835"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M513.7,506.75a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,513.7,506.75Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.57,
    cy: 453.79,
    r: 4,
    fill: "url(#3aadb8f9-666e-44d7-8850-101ab777324b)"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.57,
    cy: 453.79,
    r: 3.56,
    fill: "#fdd835"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M521.12,508.82a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,521.12,508.82Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.56,
    cy: 460.31,
    r: 4,
    fill: "url(#8a24a864-6935-4c5d-9285-913af504c66f)"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.56,
    cy: 460.31,
    r: 3.56,
    fill: "#fdd835"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M501.1,515.35a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,501.1,515.35Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 465.5,
    r: 4,
    fill: "url(#dc6daa62-5d4c-4b0d-b132-80f8e3c8a1bb)"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 465.5,
    r: 3.56,
    fill: "#fdd835"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M503.92,520.54a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,503.92,520.54Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.3,
    cy: 471.58,
    r: 4,
    fill: "url(#10616889-139f-4dbb-a319-f69cc7e747c5)"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.3,
    cy: 471.58,
    r: 3.56,
    fill: "#fdd835"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M505.85,526.62a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,505.85,526.62Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.57,
    cy: 469.65,
    r: 4,
    fill: "url(#d622a388-77b1-4bb5-b611-9789e59da2f2)"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.57,
    cy: 469.65,
    r: 3.56,
    fill: "#fdd835"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M517.11,524.69a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,517.11,524.69Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.14,
    cy: 466.09,
    r: 4,
    fill: "url(#aba0b6cd-97d1-4fa6-b49c-03842d38332e)"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.14,
    cy: 466.09,
    r: 3.56,
    fill: "#fdd835"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M528.68,521.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,528.68,521.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.84,
    cy: 462.98,
    r: 4,
    fill: "url(#5ca9418e-2b14-4da6-bfa5-c3bb69ced3c3)"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.84,
    cy: 462.98,
    r: 3.56,
    fill: "#fdd835"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.8,
    cy: 462.68,
    r: 3.56,
    fill: "#fdd835"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M532.38,518a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,532.38,518Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.62,
    cy: 470.09,
    r: 4,
    fill: "url(#676912ef-31ab-495b-b41f-eacc4c968bb5)"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.62,
    cy: 470.09,
    r: 3.56,
    fill: "#fdd835"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M538.17,525.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,538.17,525.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.94,
    cy: 474.99,
    r: 4,
    fill: "url(#d653a025-b5bb-4bff-a013-e6012a1b50df)"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.94,
    cy: 474.99,
    r: 3.56,
    fill: "#fdd835"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M519.49,530a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,519.49,530Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.34,
    cy: 473.21,
    r: 4,
    fill: "url(#69076bc3-909d-469f-9f3d-2c2fc4fb7896)"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.34,
    cy: 473.21,
    r: 3.56,
    fill: "#fdd835"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M498.88,528.25a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,498.88,528.25Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.55,
    cy: 468.02,
    r: 4,
    fill: "url(#9e21f1f9-2811-485c-b403-d55dfb297082)"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.55,
    cy: 468.02,
    r: 3.56,
    fill: "#fdd835"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M493.1,523.06a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,493.1,523.06Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.11,
    cy: 465.5,
    r: 4,
    fill: "url(#7b332ac6-e439-4d8e-b49b-3940eac480ec)"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.11,
    cy: 465.5,
    r: 3.56,
    fill: "#fdd835"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M500.66,520.54a3.56,3.56,0,0,1,6-2.55A3.56,3.56,0,1,0,501,522,3.54,3.54,0,0,1,500.66,520.54Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.96,
    cy: 459.42,
    r: 4,
    fill: "url(#8a64d9b2-e5fa-4ff9-b7f2-7551348d69a8)"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.96,
    cy: 459.42,
    r: 3.56,
    fill: "#fdd835"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M496.51,514.46a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,496.51,514.46Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.52,
    cy: 453.79,
    r: 4,
    fill: "url(#c02cfaa7-e5bb-4529-a018-becb6edff9e0)"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.52,
    cy: 453.79,
    r: 3.56,
    fill: "#fdd835"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M500.06,508.82a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,500.06,508.82Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.51,
    cy: 474.54,
    r: 4,
    fill: "url(#1adc4b7e-2266-4120-9a2c-b1ee45f93a38)"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.51,
    cy: 474.54,
    r: 3.56,
    fill: "#fdd835"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M531.05,529.58a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,531.05,529.58Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "378.04 540.67 333.76 540.67 322.54 474.54 389.41 474.54 378.04 540.67",
    fill: "url(#0795952b-89fa-4d91-9b87-264086ebf15d)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 539.78 334.7 539.78 323.88 475.58 388.37 475.58 377.4 539.78",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.88 475.58 334.85 475.58 345.23 539.78 334.55 539.78 323.88 475.58",
    fill: "#ff9100"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "388.37 475.58 377.25 475.58 366.58 539.78 377.4 539.78 388.37 475.58",
    fill: "#ff9100"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 350.57,
    y: 475.58,
    width: 10.67,
    height: 64.2,
    fill: "#ff9100"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.89,
    cy: 463.57,
    r: 4,
    fill: "url(#e195c42c-b3fa-428e-a6c2-bba40b68f175)"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.89,
    cy: 463.57,
    r: 3.56,
    fill: "#fbc02d"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M494.43,518.61a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,494.43,518.61Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.97,
    cy: 452.3,
    r: 4,
    fill: "url(#7ce678f8-f7f8-4e84-9755-f16c000a5f68)"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.97,
    cy: 452.3,
    r: 3.56,
    fill: "#fbc02d"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M504.51,507.34a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,504.51,507.34Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.88,
    cy: 469.65,
    r: 4,
    fill: "url(#3b59fc91-8ed7-45d4-a55f-b7cd94fa4927)"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.88,
    cy: 469.65,
    r: 3.56,
    fill: "#fbc02d"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M490.43,524.69a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,490.43,524.69Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.09,
    cy: 442.46,
    r: 4,
    fill: "url(#27db5171-e4a6-4c23-bbce-6aa5a76b2996)"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.09,
    cy: 442.46,
    r: 3.56,
    fill: "#fbc02d"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M485.63,497.49a3.56,3.56,0,0,1,6-2.55A3.56,3.56,0,1,0,486,499,3.54,3.54,0,0,1,485.63,497.49Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.93,
    cy: 419.52,
    r: 4,
    fill: "url(#0249779b-e172-4f2c-bc04-7c0ea3dc82da)"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.93,
    cy: 419.52,
    r: 3.56,
    fill: "#fbc02d"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M502.47,474.55a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,502.47,474.55Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.45,
    cy: 402.09,
    r: 4,
    fill: "url(#8c79d8d6-8823-4951-aba4-5a7a6f2c3a58)"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.45,
    cy: 402.09,
    r: 3.56,
    fill: "#fdd835"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M517,457.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,517,457.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.62,
    cy: 439.55,
    r: 4,
    fill: "url(#7795da92-9f14-4819-a547-b8a7b14d0f76)"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.62,
    cy: 439.55,
    r: 3.56,
    fill: "#fdd835"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M545.16,494.59a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,545.16,494.59Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.98,
    cy: 468.01,
    r: 4,
    fill: "url(#bdf0b6a6-0933-42ca-a691-eb2c3d31370e)"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.98,
    cy: 468.01,
    r: 3.56,
    fill: "#fdd835"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M567.52,523a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,567.52,523Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.93,
    cy: 537.41,
    r: 4,
    fill: "url(#19d358ce-d419-48e7-8d0d-9cc1ca4b52b3)"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.93,
    cy: 537.41,
    r: 3.56,
    fill: "#fbc02d"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M484.47,592.45a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,484.47,592.45Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.41,
    cy: 530.15,
    r: 4,
    fill: "url(#bb844668-b85d-4994-a071-4f4811cb4197)"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.41,
    cy: 530.15,
    r: 3.56,
    fill: "#fdd835"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M479,585.19a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,479,585.19Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.92,
    cy: 490.95,
    r: 4,
    fill: "url(#d3ce0fc7-ecf4-4243-94a7-e2b842d9cf5c)"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.92,
    cy: 490.95,
    r: 3.56,
    fill: "#fbc02d"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M475.47,546a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,475.47,546Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.42,
    cy: 534.22,
    r: 4,
    fill: "url(#6f3cd359-6fc0-4598-8206-402359b2f73e)"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.42,
    cy: 534.22,
    r: 3.56,
    fill: "#fbc02d"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M551,589.25a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,551,589.25Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.68,
    cy: 529.57,
    r: 4,
    fill: "url(#6037da8c-05f4-404a-bd66-d108e4c067bf)"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.68,
    cy: 529.57,
    r: 3.56,
    fill: "#fbc02d"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M558.22,584.61a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,558.22,584.61Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.55,
    cy: 535.09,
    r: 4,
    fill: "url(#af7b7254-cc98-45fd-8632-1da35d19935d)"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.55,
    cy: 535.09,
    r: 3.56,
    fill: "#fdd835"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M559.1,590.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,559.1,590.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.45,
    cy: 535.09,
    r: 4,
    fill: "url(#47b45e98-f2fc-4393-9279-4f14e53f125e)"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.45,
    cy: 535.09,
    r: 3.56,
    fill: "#fdd835"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M544,590.13a3.56,3.56,0,0,1,6-2.55,3.56,3.56,0,1,0-5.7,4.06A3.54,3.54,0,0,1,544,590.13Z",
    transform: "translate(-161.21 -54)",
    fill: "#fff",
    opacity: 0.2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(664.86 472.82)",
    opacity: 0.7,
    fontSize: 39.81,
    fontFamily: "Lato-Light, Lato"
  }, "9")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M957.64,441.23c-21.71-18.66-45.29-34.93-63.43-46.53a60.64,60.64,0,0,0,2-8.56h.15c2.93,0,5.31-4.46,5.31-10A13.82,13.82,0,0,0,899.4,368q.31-3.15.32-6.39a63.82,63.82,0,0,0-2-15.92,22.24,22.24,0,0,0,1.11-5.87,17.75,17.75,0,0,1,.56-4.78,18.75,18.75,0,0,1,2.38-4.09,25.86,25.86,0,0,0,2.31-23.43c-1.07-2.65-2.8-5.3-5.51-6.23a5.84,5.84,0,0,1-2-.82,3.56,3.56,0,0,1-1-2.64c-.15-3.31.79-6.57.9-9.89s-.9-7-3.77-8.66a10.82,10.82,0,0,0-5.64-1,53.19,53.19,0,0,0-12.27,1.7c-6.3,1.64-13.35,4.35-18.91,1a46.08,46.08,0,0,1-4.28-3.45c-7.27-5.71-19.12-4.17-24.69,3.21-2.78,3.69-4.22,8.6-8.13,11.06-7.15,4.5-17.94-2-24.52,3.36-4.94,4-4.05,12-8,17s-9.25,7.19-9.75,14.52a10.87,10.87,0,0,0,2,7.59,63.44,63.44,0,0,0-6.19,27.42q0,3.23.32,6.39a13.82,13.82,0,0,0-2.31,8.21c0,5.5,2.38,10,5.31,10h.15a60.62,60.62,0,0,0,2.19,9c-18,11.57-41.29,27.66-62.73,46.08,6.64,39.81,59.72,65,59.72,65V586L766,587.62a22,22,0,0,0-17.58,25.65l32.73,175.35a6.66,6.66,0,0,0,7.77,5.32l5.94-1.11V796c-6.27,3-10.62,4.42-10.62,11.82v2.71h38.49v-2.71c0-6.86-3.74-7.93-9.29-11.13v-7.35l5.44-1a6.66,6.66,0,0,0,5.32-7.77L793.58,616.41h84.89L847.82,780.59a6.66,6.66,0,0,0,5.32,7.77l5.44,1v7.35c-5.55,3.2-9.29,4.26-9.29,11.13v2.71h38.49v-2.71c0-7.4-4.35-8.85-10.62-11.82v-3.19L883.1,794a6.66,6.66,0,0,0,7.77-5.32L924,611.11A19.79,19.79,0,0,0,908.18,588L897.07,586v-79.7c0-.65,0-1.29,0-1.93l.9,1.93S951,481,957.64,441.23Zm-193.28,8L799.29,425a60.79,60.79,0,0,0,22.14,10.52V447a60.85,60.85,0,0,0-24.84,12.7ZM850.62,447v-11.5a60.79,60.79,0,0,0,22.53-10.83l35.38,24.55-32.22,10.49.57,1.23A60.89,60.89,0,0,0,850.62,447Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#569c99fc-09ad-4de9-aa6f-12061deb3b46)"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 635.59,
    y: 714.79,
    width: 17.72,
    height: 24.05,
    fill: "#fdb797"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 696.35,
    y: 714.79,
    width: 17.72,
    height: 24.05,
    fill: "#fdb797"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 616.61,
    y: 517.32,
    width: 116.45,
    height: 41.77,
    fill: "#4d8af0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.61,
    y: 517.32,
    width: 116.45,
    height: 41.77
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M777.82,578.92S821.27,589,836,589s58.23-10.13,58.23-10.13v-6.33H777.82Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M894.27,577.65S850.82,587.78,836,587.78s-58.23-10.13-58.23-10.13V508A58.23,58.23,0,0,1,836,449.81h0A58.23,58.23,0,0,1,894.27,508Z",
    transform: "translate(-161.21 -54)",
    fill: "#3ad29f"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M660.91,366.69h27.85a0,0,0,0,1,0,0v34.57a11,11,0,0,1-11,11h-5.85a11,11,0,0,1-11-11V366.69a0,0,0,0,1,0,0Z",
    fill: "#fdb797"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M820.88,776.88,790,782.65a5.17,5.17,0,0,1-6-4.13L751.79,606.26a17.06,17.06,0,0,1,13.64-19.91l19.21-3.59a5.17,5.17,0,0,1,6,4.13l34.34,184A5.17,5.17,0,0,1,820.88,776.88Z",
    transform: "translate(-161.21 -54)",
    fill: "#4d8af0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M851.21,776.88l30.9,5.77a5.17,5.17,0,0,0,6-4.13l32.47-173.93a15.36,15.36,0,0,0-12.28-17.91l-20.89-3.9a5.17,5.17,0,0,0-6,4.13l-34.34,184A5.17,5.17,0,0,0,851.21,776.88Z",
    transform: "translate(-161.21 -54)",
    fill: "#4d8af0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M822.12,441.79a58.26,58.26,0,0,0,27.85,0V422H822.12Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.83,
    cy: 316.06,
    r: 60.76,
    fill: "#ffcf51"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.83,
    cy: 329.99,
    r: 58.23,
    fill: "#fdb797"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 732.43,
    cy: 329.99,
    rx: 5.06,
    ry: 9.49,
    fill: "#fdb797"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.24,
    cy: 329.99,
    rx: 5.06,
    ry: 9.49,
    fill: "#fdb797"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M639.84,728.71h8a14.38,14.38,0,0,1,14.38,14.38V749a0,0,0,0,1,0,0H625.47a0,0,0,0,1,0,0v-5.88A14.37,14.37,0,0,1,639.84,728.71Z",
    fill: "#333"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M701.86,728.71h8a14.38,14.38,0,0,1,14.38,14.38V749a0,0,0,0,1,0,0H687.49a0,0,0,0,1,0,0v-5.88A14.37,14.37,0,0,1,701.86,728.71Z",
    fill: "#333"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(665.34 473.65)",
    fontSize: 37.97,
    fill: "#fff",
    fontFamily: "Lato-Light, Lato"
  }, "9")), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M782.88,352.34s-2.53,16.46,11.39,7.59,62-5.06,77.21,7.59,20.25,2.53,22.78,0-27.4-44.81-44.3-48.1C804.4,310.57,782.88,352.34,782.88,352.34Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M782.88,351.08s-2.53,16.46,11.39,7.59,62-5.06,77.21,7.59,20.25,2.53,22.78,0-27.4-44.81-44.3-48.1C804.4,309.3,782.88,351.08,782.88,351.08Z",
    transform: "translate(-161.21 -54)",
    fill: "#ffcf51"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M788.6,322.83c3.81-4.71,3-12.39,7.67-16.19,6.27-5.06,16.56,1.09,23.38-3.2,3.73-2.35,5.1-7,7.75-10.55,5.31-7,16.61-8.51,23.55-3.07a44,44,0,0,0,4.08,3.29c5.3,3.23,12,.64,18-.92a50.73,50.73,0,0,1,11.7-1.62,10.32,10.32,0,0,1,5.38,1c2.74,1.57,3.7,5.11,3.6,8.26s-1,6.27-.86,9.43a3.39,3.39,0,0,0,.92,2.52,5.57,5.57,0,0,0,1.87.78c2.58.88,4.24,3.41,5.26,5.94a24.66,24.66,0,0,1-2.2,22.35,17.88,17.88,0,0,0-2.27,3.9,16.93,16.93,0,0,0-.54,4.56c-.29,5.39-2.58,11.21-7.48,13.47-6.31,2.92-13.42-1.12-19.65-4.22-14.14-7-30.08-9.46-45.79-11.11a182.07,182.07,0,0,0-21.21-1.26c-5.27.06-12.4,2.32-17.42.18-4-1.71-5.38-5.53-5.09-9.67C779.78,329.69,784.71,327.65,788.6,322.83Z",
    transform: "translate(-161.21 -54)",
    fill: "#ffcf51"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M798.42,463.61l-30.73-10,62-43-19-26.58s-48.49,26.45-89.87,62c6.33,38,57,62,57,62Z",
    transform: "translate(-161.21 -54)",
    fill: "#3ad29f"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M874.47,463.61l30.73-10-62-43,19-26.58s48.49,26.45,89.87,62c-6.33,38-57,62-57,62Z",
    transform: "translate(-161.21 -54)",
    fill: "#3ad29f"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M812,385.25s31.64-22.78,39.24-8.86S831,411.83,831,411.83Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M810.73,384s31.64-22.78,39.24-8.86-20.25,35.44-20.25,35.44Z",
    transform: "translate(-161.21 -54)",
    fill: "#fdb797"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M810.73,384s31.64-22.78,39.24-8.86-20.25,35.44-20.25,35.44Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.02
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M860.09,385.25s-31.64-22.78-39.24-8.86,20.25,35.44,20.25,35.44Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M861.36,384s-31.64-22.78-39.24-8.86,20.25,35.44,20.25,35.44Z",
    transform: "translate(-161.21 -54)",
    fill: "#fdb797"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M861.36,384s-31.64-22.78-39.24-8.86,20.25,35.44,20.25,35.44Z",
    transform: "translate(-161.21 -54)",
    opacity: 0.02
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f6e51fcf-3a26-4c81-b90c-a65f1d2dd7ad",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.18,477.72l-2.51-6-26.61,10.93a3.29,3.29,0,0,0-2,3V514.4l7.69.89V487.87Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#ae5f3eae-4eb6-4770-bfe2-0c740001d1d9)"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "02e372b1-3203-4da5-9392-331bbc0e0a34",
    "data-name": "<Clipping Path>",
    d: "M769.91,477.6,768,473.06l-24.9,10.23a3.07,3.07,0,0,0-1.91,2.84V513h4.92V487.36Z",
    transform: "translate(-161.21 -54)",
    fill: "#f2f2f2"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9173947b-3e82-482d-9aac-5eef3c2c1e15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.13,
    y: 414.11,
    width: 5.36,
    height: 16.99,
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.64,
    y: 417.69,
    width: 5.36,
    height: 16.99,
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.74 432.21 584.94 433.33 583.37 415.23 588.74 415.23 588.74 432.21",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.9,
    y: 482.41,
    width: 5.36,
    height: 16.99,
    transform: "translate(92.46 1181.49) rotate(-90)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.9,
    y: 489.79,
    width: 5.36,
    height: 16.99,
    transform: "translate(85.09 1188.87) rotate(-90)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.9,
    y: 497.17,
    width: 5.36,
    height: 16.99,
    transform: "translate(77.71 1196.24) rotate(-90)",
    fill: "#ff9100"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "613.32 454.34 553.65 454.34 553.65 463.75 557.72 463.75 566.02 539.94 601.68 539.94 609.05 463.31 613.32 463.31 613.32 454.34",
    fill: "url(#6d82e1f1-f898-4ccf-abdb-ac811c1cde0e)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "600.13 538.38 567.28 538.38 559.23 457.92 607.29 457.92 600.13 538.38",
    fill: "#ff9100"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 555.88,
    y: 456.58,
    width: 54.98,
    height: 5.36,
    fill: "#ff9100"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.37,
    cy: 493.68,
    r: 13.63,
    fill: "url(#62368fd5-dc9d-409d-ac85-527288a57f36)"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.37,
    cy: 493.68,
    r: 12.52,
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.2,159.32A13.38,13.38,0,0,0,874,159l.52-1a13.41,13.41,0,0,0-5.39-18.19h0A13.41,13.41,0,0,0,851,145.27l-4.57,8.42h0l9.44-17.4a12.13,12.13,0,0,0-4.88-16.45l-2.25-1.22a12.13,12.13,0,0,0-16.45,4.88l22.14-40.79a19.37,19.37,0,0,0-7.79-26.27l-1.5-.81A13.41,13.41,0,0,0,826.92,61l-34.43,63.43h0l-53.62,98.79,52.2,28.33A53,53,0,0,0,863,230.26l19.19-35.36h0l9.44-17.4A13.41,13.41,0,0,0,886.2,159.32Z",
    transform: "translate(-161.21 -54)",
    fill: "url(#94a3214b-e7fc-44ad-82af-79045aa80b8c)"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M802.54,144.88H869.2a0,0,0,0,1,0,0V253a0,0,0,0,1,0,0H761a0,0,0,0,1,0,0V186.38A41.5,41.5,0,0,1,802.54,144.88Z",
    transform: "translate(1275.4 708.66) rotate(-151.51)",
    fill: "#ff9100"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M863,157.26h25.81a0,0,0,0,1,0,0v21.46a10.5,10.5,0,0,1-10.5,10.5h-4.81a10.5,10.5,0,0,1-10.5-10.5V157.26A0,0,0,0,1,863,157.26Z",
    transform: "translate(1401.94 689.32) rotate(-151.51)",
    fill: "#ff9100"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M846.6,138.55h25.81a0,0,0,0,1,0,0V160a10.5,10.5,0,0,1-10.5,10.5H857.1A10.5,10.5,0,0,1,846.6,160V138.55a0,0,0,0,1,0,0Z",
    transform: "translate(1380 646.35) rotate(-151.51)",
    fill: "#ff9100"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M828,118.68h25.81a0,0,0,0,1,0,0v22.46a9.5,9.5,0,0,1-9.5,9.5h-6.81a9.5,9.5,0,0,1-9.5-9.5V118.68A0,0,0,0,1,828,118.68Z",
    transform: "translate(1354.57 600.15) rotate(-151.51)",
    fill: "#ff9100"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M810.72,56.11h33.19a0,0,0,0,1,0,0v73.08a10.5,10.5,0,0,1-10.5,10.5h-7.52a15.17,15.17,0,0,1-15.17-15.17V56.11A0,0,0,0,1,810.72,56.11Z",
    transform: "translate(1346.53 524.59) rotate(-151.51)",
    fill: "#ff9100"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 856.54,
    y: 164.65,
    width: 14.75,
    height: 61.46,
    rx: 6,
    ry: 6,
    transform: "translate(1368.79 725.2) rotate(-151.51)",
    fill: "#ff9100",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 840.7,
    y: 144.87,
    width: 14.75,
    height: 61.46,
    rx: 6,
    ry: 6,
    transform: "translate(1348.47 680.48) rotate(-151.51)",
    fill: "#ff9100",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 823.29,
    y: 122.84,
    width: 14.75,
    height: 61.46,
    rx: 6,
    ry: 6,
    transform: "translate(1326.28 630.77) rotate(-151.51)",
    fill: "#ff9100",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 817.3,
    y: 72.04,
    width: 14.75,
    height: 61.46,
    rx: 6,
    ry: 6,
    transform: "translate(1339.25 532.46) rotate(-151.51)",
    fill: "#ff9100",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M784.9,222.42s19.1-12-.47-35.21l39.19-20.68s8.3-17.87-17.69-13.79-24.5,9.08-24.5,9.08",
    transform: "translate(-161.21 -54)",
    fill: "#ff9100",
    stroke: "#fff",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.87f37f7552be8985f047b1c0dd34abb2.svg";
export { ForwardRef as ReactComponent };